<!-- Header -->
<div class="sub-header">
  <div class="container" style="height: 100%;">
    <div class="controls-panel d-flex align-items-center justify-content-between">
      <div class="header-name">PNC Report</div>
      <div>
        <button type="button" class="btn btn-bvq default ml-2" (click)="goBack()">
          <i class="fa fa-angle-left mr-1"></i>
          Back
        </button>
        <button type="button" class="btn btn-bvq ml-2" (click)="saveReport()"
          [disabled]="!reportForm.valid">
          <i class="fa fa-floppy-o mr-1"></i>
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<!-- List of IBIS -->
<div class="container pb-3" [hidden]="loading" id="pncReport">
  <form #reportForm="ngForm">
    <div class="row">
      <div class="col-md-3 left-panel">
        <div class="items">
          <div class="tutorial" [ngClass]="{'active': item.SELECTED}" *ngFor="let item of navBarItems">
            <div class="name" (click)="onSelect(item)">{{item.NAME}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-9 report-container">
        <!-- Date -->
        <div class="row mt-4" id="BASIC_INFO">
          <div class="col-md-3">
            <div class="form-group mb-0">
              <label>Date</label>
              <input type="text" class="form-control" placeholder="MM-YYYY"
                bsDatepicker [bsConfig]="{ dateInputFormat: 'MM-YYYY' }" [maxDate]="today"
                [(ngModel)]="pncReport.DATE" name="Date" readonly required
                (onShown)="onOpenCalendar($event)" (ngModelChange)="formatDate()"/>
            </div>
          </div>
        </div>

        <!-- Executive Summary -->
        <div class="row mt-3" id="EXECUTIVE_SUMMARY">
          <div class="col-md-12 pr-0">
            <label>Executive Summary</label>
            <quill-editor name="EXECUTIVE_SUMMARY" [(ngModel)]="pncReport.EXECUTIVE_SUMMARY"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Summary Table -->
        <div class="row mt-3" id="SUMMARY_TABLE">
          <div class="col-md-12 pr-0">
            <label>Summary Table</label>
            <quill-editor name="INDUSTRY_DEFINITION" [(ngModel)]="pncReport.SUMMARY_TABLE"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- GDP Description -->
        <div class="row mt-3" id="GDP_DESCRIPTION">
          <div class="col-md-12 pr-0">
            <label>GDP Description</label>
            <quill-editor name="GDP_DESCRIPTION" [(ngModel)]="pncReport.GDP_DESCRIPTION" [modules]="quillModules"
                          placeholder="According to the table above, the real GDP is forecasted to increase at"></quill-editor>
          </div>
        </div>

        <!-- GDP Key Points -->
        <div class="row mt-3" id="GDP_KEY_POINTS">
          <div class="col-md-12 pr-0">
            <label>GDP Key Points</label>
            <quill-editor name="GDP_KEY_POINTS" [(ngModel)]="pncReport.GDP_KEY_POINTS" [modules]="quillModules"
                          placeholder="List of Key Points"></quill-editor>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>

